
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndWarranty",
      function () {
        return require("private-next-pages/remyndWarranty/index.tsx");
      }
    ]);
  